<div id="transaction-details-section">
  <span id="subtitle">{{ pageHeader }}</span>

  <!-- TRANSACTION TYPE -->
  <mm-label-group id="viewPage_transactionTypeLabel" data-testid="viewPage_transactionTypeLabel"
    [title]="labels.transactionType" [data]="transactionType" ></mm-label-group>

  <!-- TRANSFER DIRECTION -->
  <div class="row">
    <mm-label-group id="viewPage_transferDirectionLabel" [title]="labels.transferDirection"
      [data]="transferDirection | titlecase"></mm-label-group>
  </div>

  <!-- SOURCE OF FUNDS/ACCOUNT TO RECEIVE FUNDS -->
  <div class="row">
    <mm-label-group id="viewPage_sourceOfFundsLabel" [title]="isAchIn ? labels.sourceOfFunds : labels.accountToReceiveFunds"
      [multilineData]="[to1, accountName, to2, accountType, abaNumber]"></mm-label-group>
  </div>

  <!-- FREQUENCY/RECURRING FREQUENCY -->
  <div class="row" *ngIf="!!frequency && isRecurring">
    <div class="col">
      <mm-label-group id="viewPage_frequencyLabel" [title]="labels.frequency" [data]="frequencyTypes.recurring"
        data-testid="viewPage_frequency"></mm-label-group>
    </div>
    <div class="col">
      <mm-label-group id="viewPage_frequencyOfOccurrenceLabel" [title]="labels.frequencyDescription"
        [data]="frequency" data-testid="viewPage_frequencyOfOccurrence"></mm-label-group>
    </div>
    <div class="col" id="spacer_column_secondCompletionDateLabel" data-testid="spacer_column_secondCompletionDate" *ngIf="secondCompletionDate"></div>
    <div class="col" id="spacer_column_endDateLabel" data-testid="spacer_column_endDate" *ngIf="endDate || isRecurring"></div>
    <div class="col" id="spacer_column_fundsAvailableToTradeDateLabel" data-testid="spacer_column_fundsAvailableToTradeDate" *ngIf="isRecurring && transferDirection === 'incoming'"></div>
  </div>

  <!-- DATES ROW -->
  <div class="row">
    <div class="col" *ngIf="isRecurring">
      <!-- NEXT WITHDRAWAL DATE -->
      <mm-label-group id="viewPage_nextExpectedWithdrawalDateLabel" data-testid="viewPage_nextExpectedWithdrawalDate" [title]="labels.nextExpectedWithdrawalDate"
        [data]=" (nextWithdrawalDate ? (nextWithdrawalDate | date : 'MM/dd/yyyy') : 'N/A')!">
      </mm-label-group>
    </div>

    <!-- NEXT COMPLETION DATE -->
    <div class="col" *ngIf="isRecurring">
      <mm-label-group id="viewPage_nextCompletionDateLabel" data-testid="viewPage_nextCompletionDate" [title]="labels.nextCompletionDate"
        [data]="(nextCompletionDate ? (nextCompletionDate | date : 'MM/dd/yyyy') : 'N/A')!">
      </mm-label-group>
    </div>

    <!-- SECOND COMPLETION DATE -->
    <div class="col" *ngIf="isRecurring && secondCompletionDate">
      <mm-label-group id="viewPage_secondCompletionDate" data-testid="viewPage_secondCompletionDate" [title]="labels.secondCompletionDate"
        [data]="(secondCompletionDate ? (secondCompletionDate | date : 'MM/dd/yyyy') : 'N/A')!">
      </mm-label-group>
    </div>

    <!-- END DATE -->
    <div class="col" *ngIf="isRecurring">
      <mm-label-group id="viewPage_endDate" data-testid="viewPage_endDate" [title]="labels.endDate" [data]="(endDate ? (endDate | date : 'MM/dd/yyyy') : 'N/A')!"></mm-label-group>
    </div>

    <!-- FUNDS AVAILABLE TO TRADE -->
    <div class="col" *ngIf="isRecurring && transferDirection === 'incoming'">
      <mm-label-group id="viewPage_fundsAvailableToTradeLabel" data-testid="viewPage_fundsAvailableToTrade" [title]="labels.fundsAvailableToTrade"
        [data]="(fundsAvailableToTrade ? (fundsAvailableToTrade | date : 'MM/dd/yyyy') : 'N/A')!">
      </mm-label-group>
      <div class="label-group">
        <span id="viewPage_fundsAvailableToTradeCopy">{{fundsAvailableToTradeCopy}}</span>
      </div>
    </div>
  </div>

  <!-- RECURRING AMOUNT/AMOUNT TYPE -->
  <div class="row" *ngIf="isRecurring">
    <div class="small-col">
      <mm-label-group id="viewPage_amountLabel" data-testid="viewPage_amount" [title]="labels.amount" [data]="amount"></mm-label-group>
    </div>
    <div class="small-col" *ngIf="isIra && transferDirection === 'outgoing'">
      <mm-label-group id="viewPage_grossNet" data-testid="viewPage_grossNet" [title]="labels.grossNet" [data]="amountType"></mm-label-group>
    </div>
  </div>

  <!-- MAX TRANSFER AMOUNT -->
  <div class="row">
    <div class="col">
      <mm-label-group id="viewPage_maxTransferAmount" data-testid="viewPage_maxTransferAmount" [title]="labels.maxTransferAmount"
        [data]="maxTransferAmount"></mm-label-group>
    </div>
  </div>

  <!-- AMOUNT TYPE -->
  <div class="row" *ngIf="isIra && !isRecurring">
    <div class="col">
      <mm-label-group id="viewPage_amountType_grossNet" data-testid="viewPage_amountType_grossNet" [title]="labels.grossNet"
        [data]="amountType"></mm-label-group>
    </div>
  </div>

  <ng-template [ngIf]="isIra && transferDirection === 'outgoing'">
    <div class="row">
      <div class="small-col">
        <!-- FED TAX PERCENT -->
        <mm-label-group id="viewPage_federalTaxLabel" [title]="labels.federalTax"
          [data]="fedTaxPercent"></mm-label-group>

          <!-- STATE TAX PERCENT -->
        <mm-label-group id="viewPage_stateTaxLabel" [title]="stateTaxLabel"
          [data]="stateTaxPercent"></mm-label-group>
      </div>

      <div class="small-col" *ngIf="isRecurring">
        <!-- FED TAX AMOUNT -->
        <mm-label-group id="viewPage_federalTaxAmountLabel" data-testid="viewPage_federalTaxAmount" [title]="labels.federalTaxAmount"
          [data]="fedTaxAmount"></mm-label-group>

          <!-- STATE TAX AMOUNT -->
        <mm-label-group id="viewPage_stateTaxAmountLabel" data-testid="viewPage_stateTaxAmount" [title]="labels.stateTaxAmount"
          [data]="stateTaxAmount"></mm-label-group>

          <!-- NET CASH TOTAL -->
        <mm-label-group id="viewPage_netAmountLabel" data-testid="viewPage_netAmount" [title]="labels.netCashAmount"
          [data]="netAmount"></mm-label-group>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="isIra">
    <div class="row">
      <div class="col">
        <div *ngIf="transferDirection === 'incoming'">
          <!-- CONTRIBUTION REASON -->
          <mm-label-group id="viewPage_contributionReasonLabel" [title]="labels.contributionReason"
            [data]="contributionReason"></mm-label-group>
        </div>

        <!-- DISTRIBUTION REASON -->
        <div *ngIf="transferDirection === 'outgoing'">
          <mm-label-group id="viewPage_distributionReasonLabel" [title]="labels.distributionReason"
            [data]="distributionReason"></mm-label-group>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- TRUST FIELDS -->
  <ng-template [ngIf]="isPtrs">
    <div class="row">
      <div class="col">
        <mm-label-group id="viewPage_trustIncomeLabel" [title]="labels.trustIncomePercent"
          [data]="trustIncomePercent ?? ''"></mm-label-group>

        <mm-label-group id="viewPage_trustTaxCodeLabel" [title]="labels.trustTaxCode"
          [data]="trustTaxCode ?? ''"></mm-label-group>
      </div>

      <div class="col">
        <mm-label-group id="viewPage_trustPrincipalLabel" [title]="labels.trustPrincipalPercent"
          [data]="trustPrincipalPercent ?? ''"></mm-label-group>

        <mm-label-group *ngIf="transferDirection === 'outgoing'" id="viewPage_trustPaidForLabel"
          [title]="labels.trustPaidFor" [data]="trustPaidFor ?? ''"></mm-label-group>

        <mm-label-group *ngIf="trustComment && isNotEmptyOrNull(trustComment)" id="viewPage_trustCommentLabel" [title]="labels.trustComment"
          [data]="trustComment"></mm-label-group>
      </div>
    </div>
  </ng-template>

  <mm-banners *ngIf="isPtrs"
    [bannerText]="[viewPagePtrsInfoBannerPrimaryText]" [boldText]="viewPagePtrsInfoBannerBoldText" [type]="'information'"
    [showCloseIcon]="false" id="viewPage_ptrsDisclaimer" data-testid="viewPage_ptrsDisclaimer"></mm-banners>

</div>
